import type { PropsWithChildren } from "react"

import type { SkeletonPropsVariantOverrides } from "@mui/material"
import { Box, Skeleton } from "@mui/material"
import type { OverridableStringUnion } from "@mui/types"

interface SkeletonWrapperProps {
  isWaiting: boolean
  variant?: OverridableStringUnion<
    "text" | "rectangular" | "rounded" | "circular",
    SkeletonPropsVariantOverrides
  >
  height?: number | string
  width?: number | string
}

const SkeletonWrapper = ({
  isWaiting,
  variant = "rounded",
  children,
  height,
  width,
}: PropsWithChildren<SkeletonWrapperProps>) => {
  return isWaiting ? (
    <Skeleton variant={variant} sx={{ overflow: "hidden" }}>
      {/* Skeleton hides its children through inheritance, which anything that sets
          `visibility: visible` itself escapes (the data grid's active sort icon does). */}
      <Box
        height={height}
        width={width}
        sx={{ "& *": { visibility: "hidden !important" } }}
      >
        {children}
      </Box>
    </Skeleton>
  ) : (
    <>{children}</>
  )
}

export default SkeletonWrapper
